import request from '@/utils/request'

let GangkouApi = {

  /*港口列表*/
  list(data) {
    return request._post('/shop/plus.gangkou.Index/index', data);
},
listx(data) {
    return request._post('/shop/plus.gangkou.Index/indexx', data);
},
/*添加港口*/
add(data) {
    return request._post('/shop/plus.gangkou.Index/add', data);
},
/*修改港口*/
edit(data) {
    return request._post('/shop/plus.gangkou.Index/edit', data);
},
/*删除港口*/
del(data) {
    return request._post('/shop/plus.gangkou.Index/del', data);
},
/*港口详情*/
detail(data) {
  return request._post('/shop/plus.gangkou.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.gangkou.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.gangkou.Setting/getSetting', data, errorback);
    },
}
export default GangkouApi;



// WEBPACK FOOTER //
// ./src/api/gangkou.js